import React, { useState } from "react";

const LikeButton = ({ initialLikes = 0 }) => {
  const [liked, setLiked] = useState(false);
  const [likes, setLikes] = useState(initialLikes);

  const toggleLike = () => {
    setLiked((prev) => !prev);
    setLikes((prev) => prev + (liked ? -1 : 1));
  };

  return (
    <div
      className={`like-icon ${liked ? "liked" : ""}`}
      onClick={toggleLike}
    >
      {likes}
    </div>
  );
};

export default LikeButton;
